Array.prototype.toggle = function <T>(
  this: T[],
  item: T,
  predicate?: (element: T) => boolean,
): T[] {
  // 배열에서 predicate에 맞는 요소를 찾음
  let index: number;
  if (predicate) {
    index = this.findIndex(predicate);
  } else {
    index = this.findIndex((el) => el === item);
  }

  if (index > -1) {
    // 조건에 맞는 요소가 있으면 배열에서 제거
    this.splice(index, 1);
  } else {
    // 조건에 맞는 요소가 없으면 새 요소를 배열에 추가
    this.push(item);
  }
  return [...this];
};

Array.prototype.upsert = function <T>(
  this: T[],
  item: T,
  predicate?: (element: T) => boolean,
): T[] {
  // 배열에서 predicate에 맞는 요소를 찾음
  let index: number;
  if (predicate) {
    index = this.findIndex(predicate);
  } else {
    index = this.findIndex((el) => el === item);
  }

  if (index > -1) {
    // 조건에 맞는 요소가 있으면 새 요소로 업데이트
    this.splice(index, 1, item);
  } else {
    // 조건에 맞는 요소가 없으면 새 요소를 배열에 추가
    this.push(item);
  }
  return [...this];
};

Array.prototype.remove = function <T>(
  this: T[],
  item: any,
  predicate?: (element: T) => boolean,
): T[] {
  // 배열에서 predicate에 맞는 요소를 찾음
  let index: number;
  if (predicate) {
    index = this.findIndex(predicate);
  } else {
    index = this.findIndex((el) => el === item);
  }

  if (index > -1) {
    // 조건에 맞는 요소가 있으면 삭제
    this.splice(index, 1);
  }

  return [...this];
};
